import script from "./fault-form-device.vue?vue&type=script&lang=ts&setup=true"
export * from "./fault-form-device.vue?vue&type=script&lang=ts&setup=true"

import "./fault-form-device.vue?vue&type=style&index=0&id=b3b02386&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3b02386"]])

export default __exports__